import {
  Checkbox,
  Fab,
  FormControlLabel,
  Grid,
  TextField,
  Typography,
  CircularProgress,
  styled
} from "@material-ui/core";
import { ErrorMessage, Form, Formik} from "formik";
import React, { FunctionComponent } from "react";
import { object as yupObject, string as yupString } from "yup";
import { useLoginStyles } from "./useLoginStyles";
import MailIcon from "@material-ui/icons/Mail";
import LockIcon from "@material-ui/icons/Lock";
import logo from "../../assets/images/webappLogo.jpg"; 

const signupSchema = yupObject().shape({
  username: yupString()
    .min(2, "Too Short!")
    .max(70, "Too Long!")
    .required("Username is required"),

  password: yupString()
    .min(2, "Too Short!")
    .max(70, "Too Long!")
    .required("Password is required"),
});

type LoginFormProps = {
  onSignin: (credentials: {
    username: string;
    password: string;
  }) => Promise<void>;
  isLoading: boolean;
};

const RedAsteriskTextField = styled(TextField)(() => ({
  "& .MuiInputLabel-asterisk": {
    color: "red",
  },
}));

export const LoginForm: FunctionComponent<LoginFormProps> = ({
  onSignin,
  isLoading,
}) => {
  const styles = useLoginStyles();
  const initialValues = {
    username: "",
    password: "",
  };
  return (
    <div>
      <Formik
        initialValues={initialValues}
        validationSchema={signupSchema}
        onSubmit={onSignin}
      >
        {({ handleChange, handleBlur  }) => (
          <Form noValidate>
            <Grid container direction="column" alignItems="center" spacing={3}>
              <Grid item>
                {/* <Typography className={styles.titlePaper}> */}
                <img src={logo} alt="Logo" />
                {/* </Typography> */}
              </Grid>
              <Grid item className={styles.textFieldwidth}>
                <Grid container spacing={1} alignItems="flex-end">
                  <Grid item>
                    <MailIcon fontSize="small" className={styles.iconColor} />
                  </Grid>
                  <Grid item xs={10}>
                    <RedAsteriskTextField
                      label="Username"
                      fullWidth={true}
                      type="text"
                      name="username"
                      onChange={handleChange}
                      required
                      onBlur={handleBlur} 
                       InputLabelProps={{
                        classes: { root: styles.labelStyle },
                       }}
                    />
                    
                     <ErrorMessage name="username">
                      {(msg) => <div style={{ color: "red" }}>{msg}</div>}
                    </ErrorMessage>
                     
                  </Grid>
                </Grid>
              </Grid>

              <Grid item className={styles.textFieldwidth}>
                <Grid container spacing={1} alignItems="flex-end">
                  <Grid item>
                    <LockIcon fontSize="small" className={styles.iconColor} />
                  </Grid>
                  <Grid item xs={10}>
                    <RedAsteriskTextField
                      label="Password"
                      fullWidth={true}
                      type="password"
                      name="password"
                      onBlur={handleBlur} 
                      onChange={handleChange}
                      required
                      InputLabelProps={{
                        classes: { root: styles.labelStyle },
                      }}
                    />
                    <ErrorMessage name="password">
                      {(msg) => <div style={{ color: "red" }}>{msg}</div>}
                    </ErrorMessage>
                  </Grid>
                </Grid>
                <Grid item xs={12}>
                  <Grid container justify="space-evenly">
                    <Grid item xs={6}>
                      <Typography
                        color="primary"
                        className={styles.forgotTypography}
                      >
                        Forgot password?
                      </Typography>
                    </Grid>
                    <Grid item xs={6}>
                      <FormControlLabel
                        className={styles.formControlLabelMarginTop}
                        control={
                          <Checkbox
                            value="checkedA"
                            color="primary"
                            className={styles.checkboxMarginLeft}
                          />
                        }
                        label={
                          <Typography
                           className={styles.rememberTypography}
                          >
                            Remember me
                          </Typography>
                        }
                      />
                    </Grid>
                  </Grid>
                </Grid>
                {/* <Grid container direction="row">
                  {/* <Typography className={styles.credentials}>
                    Enter your password
                  </Typography> */}
                {/* </Grid> */}
              </Grid>

              <Grid item>
                <Fab
                  variant="extended"
                  color="primary"
                  className={styles.fab}
                  type="submit"
                  disabled={isLoading}
                >
                  Sign In
                </Fab>
                {isLoading && (
                  <CircularProgress
                    size={24}
                    className={styles.buttonProgress}
                  />
                )}
              </Grid>
            </Grid>
          </Form>
        )}
      </Formik>
    </div>
  );
};
